import gql from 'graphql-tag';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { statusBannerFire } from 'actions/statusBanner';
import { graphql } from 'graphql/utils';
import { get } from 'utils';

export const withData = () =>
    compose(
        connect(undefined, { setStatusBanner: statusBannerFire }),
        graphql(
            gql`
                query withNewsSourceTags {
                    tags(filter: { tagType: news_source }) {
                        id
                        displayName
                    }
                }
            `,
            {
                props: ({ data }) => ({
                    options: get(data, 'tags', []).map(({ id, displayName }) => ({ value: id, label: displayName }))
                }),
                options: {
                    fetchPolicy: 'cache-first'
                }
            }
        )
    );
